import { Vehicule } from "@/models";
import { Http } from "@/utils/http";

/** Backend calls for vehicle fleet management. */
export default class VehiculeService {
  /** Lists vehicles with full detail. */
  public static async vehicules(): Promise<Vehicule[]> {
    const targetUrl = `${process.env.VUE_APP_API_APP}/?task=vehiculesInformations`;
    const { data: response } = await Http.instance.get(targetUrl);
    return response.data;
  }
  /** Lists nearby fuel/service stations (proxied from the public carburants open data API). */
  public static async stationServices(): Promise<any> {
    const targetUrl = `${process.env.VUE_APP_API_APP}/?task=vehiculesStationsServices`;
    const { data: response } = await Http.instance.get(targetUrl);
    return response.data;
  }
}
